// Categories that represent internal money movement (transfers between
// your own accounts, credit card autopay, moving money to/from brokerage)
// or one-off property transactions, rather than real income or spending.
// Excluded from totals and category-based views app-wide - Overview cards,
// Transaction Details, category cost/trend charts, and the Home page's
// per-profile summary - so that number means the same thing everywhere
// it's shown. Not user-configurable yet; if that changes, this becomes
// the single place consumers read the current list from instead of each
// hardcoding it separately.
export const DEFAULT_EXCLUDED_CATEGORIES = ['MONEY_MOVEMENT', 'PROPERTY_INVESTMENT'];
